<template>
    <div>
        <el-dialog center :visible.sync="dialogVisible" :width="width">
            <div slot="title">
                <h4>{{ $t(title) }}</h4>
            </div>
            <div>
                <div class="center mt">{{ $t(content) }}</div>
                <el-input type="textarea" style="word-break: normal ;overflow-wrap: break-word;" :autosize="{ minRows: 1, maxRows: 15}" readonly class="margin-t"
                    :value="link"></el-input>
            </div>
            <div slot="footer">
                <el-button v-clipboard:copy="link" icon="el-icon-document-copy" v-clipboard:success="firstCopySuccess"
                    v-clipboard:error="firstCopyError" type="primary" round style="width:200px">{{ $t('一键复制')
                    }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "shareDialog",
    data() {
        return {
            dialogVisible: false,
            title: "分享",
            content: "",
            link: "",
            width: '600px'
        };
    },
    props: {
    },
    methods: {
        show(title, link, content, width) {
            if (width) {
                this.width = width
            } else {
                this.width = '600px'
            }
            this.title = title;
            this.link = link;
            if (content) {
                this.content = content;
            }
            this.dialogVisible = true;
        },

        firstCopySuccess() {
            this.dialogVisible = false;
            this.$message({
                message: this.$t('复制成功'),
                type: 'success'
            });
        },
        firstCopyError() {
            console.log("copy err");
        }
    },
};
</script>
<style scoped>
.drawer {
    padding: 30px 13%;
}

.drawer>>>.el-input__inner {
    border-radius: 20px;
    border-color: #eeeeee;
}
</style>
